


































import Vue from 'vue'
import { Portal } from 'portal-vue'

export default Vue.extend({
  components: {
    Portal,
  },
  props: {
    tag: {
      type: String as () => string,
      default: 'Portal',
    },
    link: {
      type: Object as () => null | { to: string; text: string },
      default: null,
    },
    show: {
      type: Boolean as () => boolean,
      default: false,
    },
  },
  data() {
    return {
      showSnackbar: false,
    }
  },
  watch: {
    showSnackbar(newVal) {
      if (newVal === true) {
        setTimeout(() => (this.showSnackbar = false), 5000)
      } else {
        this.$emit('update:show', newVal)
      }
    },
    // propsでsnackbarを表示する場合に使う
    show(newVal) {
      this.showSnackbar = newVal
    },
  },
})
